// Admin-only carrier capability source.
//
// This module is intentionally scoped under components/admin/ so it is never
// imported by client quote special-needs code (frontend/src/components/user/*).
// It is the single source of truth for the hardcoded equipment-type list used
// by the carrier list, carrier filters, and carrier form.

export const EQUIPMENT_TYPES: string[] = [
  'Low Loader',
  'Semi Low Loader',
  'Open / Mega',
  'Extendable',
  'Flatbed',
  'HIAB / Grua',
  'Modular (SPMT)',
  'ADR',
  'Escolta própria',
  'Outros equipamentos',
];
